import stEquifaxAuth from '../equifax/equifaxAuth.component';
import stEquifaxDialog from '../equifax/equifaxDialog.component';

export default angular
  .module('st.Integrations.Equifax', ['st.Core'])
  .component('stEquifaxAuth', stEquifaxAuth)
  .component('stEquifaxDialog', stEquifaxDialog)
  .service('equifaxService', ($q, $http, $rootScope, dataService, EQUIFAX) => ({
    getScoreAndReport: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        EQUIFAX.API.GET_SCORE_AND_REPORT,
        {
          __requestConfiguration: {
            timeout: 240000
          },
          params
        },
        null,
        true
      ),
    getPreviousReport: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        EQUIFAX.API.GET_PREVIOUS_REPORT,
        {
          __requestConfiguration: {
            timeout: 240000
          },
          params
        },
        null,
        true
      )
  }))
  .constant('EQUIFAX', {
    API: {
      GET_SCORE_AND_REPORT: '/api/v1/integration/equifax/get-score-and-pdf-report/',
      GET_PREVIOUS_REPORT: '/api/v1/integration/equifax/get-pdf-report-previous-enquiry/'
    },
    EQUIFAX_ACCOUNT_TYPES: [
      { id: 'AL', value: 'Auto Loan' },
      { id: 'CC', value: 'Continuing Credit Contract' },
      { id: 'CA', value: 'Charge Card' },
      { id: 'OD', value: 'Overdraft' },
      { id: 'PF', value: 'Personal Loan (fixed term)' },
      { id: 'PR', value: 'Personal Loan (revolving )' },
      { id: 'RE', value: 'Equipment Hire or Rental' },
      { id: 'RM', value: 'Real Property Mortgage' },
      { id: 'TC', value: 'Telecommunications Services' },
      { id: 'UA', value: 'Utilities' }
    ],
    EQUIFAX_ACCOUNT_RELATIONSHIP: [
      { id: 1, value: "Principal's Account(sole)" },
      { id: 2, value: "Principal's Account(joint)" },
      { id: 3, value: 'Guarantor' },
      { id: 4, value: 'Director' }
    ]
  });
